import { ContextMenu as BaseContextMenu } from '@base-ui/react/context-menu'
import type { PartProps } from '../../../lib/part-props'

interface ContextMenuPortalProps extends PartProps<BaseContextMenu.Portal.Props> {}

function ContextMenuPortal({ children, ...props }: ContextMenuPortalProps) {
  return <BaseContextMenu.Portal {...props}>{children}</BaseContextMenu.Portal>
}

export { ContextMenuPortal }
